export default "__VITE_ASSET__oSmXOjb$__"